import React from "react";
import { Honeybadger, HoneybadgerErrorBoundary } from "@honeybadger-io/react";
import ReactDOM from "react-dom/client";
import "@/styles/index.scss";
import "@/locale";
import App from "@/App";
import "helpers/clarity";
import isE2e from "@/helpers/isE2e";
import packageJson from "../package.json";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const key = import.meta.env.VITE_HONEYBADGER_API_KEY;

if ([undefined, "false"].includes(key) || import.meta.env.MODE === "development" || isE2e) {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const environment =
    import.meta.env.MODE === "production" && import.meta.env.VITE_PREVIEW_RELEASE === "false"
      ? "production"
      : "staging";

  const config = {
    apiKey: key,
    environment: environment,
    revision: packageJson.version,
  };

  const honeybadger = Honeybadger.configure(config);

  root.render(
    <HoneybadgerErrorBoundary honeybadger={honeybadger}>
      <App />;
    </HoneybadgerErrorBoundary>
  );
}
